import { Options, Vue } from "vue-class-component";
import { Authentication } from '@/modules/authentication/authentication';
import { SELF_URL } from '@/config';
import { Url } from '@/config/url';
import { AuthenticationStatusType, AuthenticationStatus } from '@/modules/authentication/authentication-status';
import { RouteN } from '@/constants/route-name';
import { AuthorizedUser } from "@/models/authorized-user";
import store from '../../store/index';
import LoadingSpinner from '../loading-spinner/index.vue';
import StdPageLayout from '@/components/std-page-layout/index.vue';

@Options({
  components: {
    LoadingSpinner,
    StdPageLayout
  }
})
export default class AutoLogin extends Vue {

  private authentication: Authentication = new Authentication(
    this.userAccount
  );

  created() {
    this.authentication.runAuthCheck(this.authCheckCallBack);
  }

  private authCheckCallBack(status: AuthenticationStatus = AuthenticationStatusType.NotLogin): void {
    const redirect: string = this.$route.query.redirect as string;
    switch (status) {
      case AuthenticationStatusType.AppAccessPermitted:
        setTimeout(() => {
          this.$router.push(
            redirect ? redirect : { name: RouteN.CMP.Main.n }
          );
        }, 0);
        break;
      case AuthenticationStatusType.AppAccessDenied:
        setTimeout(() => { this.$router.push({ name: RouteN.NoAccess.n }); }, 0);
        break;
      case AuthenticationStatusType.NotLogin:
        setTimeout(() => { document.location.href = SELF_URL + Url.Login; }, 0);
        break;
      default:
        setTimeout(() => { document.location.href = SELF_URL + Url.Logout; }, 0);
        break;
    }
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }
}
